'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _titleSection = require('./common/title-section');

var _titleSection2 = _interopRequireDefault(_titleSection);

var _bodySection = require('./common/body-section');

var _bodySection2 = _interopRequireDefault(_bodySection);

var _ctaSection = require('./common/cta-section');

var _ctaSection2 = _interopRequireDefault(_ctaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'How To Sign Online SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'How to Sign Online',
            subtitle: 'Ready to start signing online? Set up your HelloSign account to create your first document.',
            buttonText: 'TRY HELLOSIGN'
        };
        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
    },

    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _jsx(_bodySection2['default'], {}, void 0, _jsx('h2', {
            className: headerClass
        }, void 0, 'What is HelloSign?'), _jsx('p', {}, void 0, 'HelloSign was created to make it easy to sign all your most important documents online. We know what a pain it is to run back and forth from the printer and scanner (if you even have one!) when completing paperwork. We also know some admin software can get complicated quickly. To solve these pain points, we focused on making a simple, sleek eSignature app that’s easy to navigate.'), _jsx('h2', {
            className: headerClass
        }, void 0, 'How do I Sign Documents Online?'), _jsx('p', {}, void 0, 'It’s super easy to start signing online! Just create a free HelloSign account, upload your document, and format the document with a signature box in the appropriate area. Once you have a signature in place, you can either insert your own signature or send the document to another party to get their signature.'), _jsx('p', {}, void 0, 'There are a few different ways to create a signature which you can ', _jsx('a', {
            href: 'http://blog.hellosign.com/signature-maker/',
            target: '_blank'
        }, void 0, 'learn about here.')), _jsx('h2', {
            className: headerClass
        }, void 0, 'What kind of documents can I sign online?'), _jsx('p', {}, void 0, 'You can sign all sorts of documents online! A few popular examples are offer letters and contracts, but it doesn’t stop there. Our customers have used HelloSign to sign:'), _jsx('ul', {
            className: listClass
        }, void 0, _jsx('li', {}, void 0, 'Vendor applications'), _jsx('li', {}, void 0, 'Escrow paperwork'), _jsx('li', {}, void 0, 'Mortgage '), _jsx('li', {}, void 0, 'Employee benefits paperwork'), _jsx('li', {}, void 0, 'Lease'), _jsx('li', {}, void 0, 'Plus more!')), _jsx('h2', {
            className: headerClass
        }, void 0, 'Is it secure to sign my documents online?'), _jsx('p', {}, void 0, 'Yep! HelloSign provides bank-level security to keep your information safe and secure. We also offer additional features that ensure that you always have full control over the journey of your document. These features include:'), _jsx('ul', {
            className: listClass
        }, void 0, _jsx('li', {}, void 0, _jsx('strong', {}, void 0, 'Time stamped audit-trails'), ' to give you an overview of every touchpoint of your document.'), _jsx('li', {}, void 0, _jsx('strong', {}, void 0, 'User permissions'), ' to securely share sensitive documents with included parties.'), _jsx('li', {}, void 0, _jsx('strong', {}, void 0, 'Two factor authentication'), ' as an added protection against for log-ins.'), _jsx('li', {}, void 0, _jsx('strong', {}, void 0, 'Signer order'), ' to ensure that the person you want signing is getting the document at the right time.')), _jsx('h2', {
            className: headerClass
        }, void 0, 'What types of industries use eSignatures to sign online?'), _jsx('p', {}, void 0, 'A lot! As eSignatures become the norm for signing, most industries have adopted some form of electronic signing. The cost and time savings associated with having an entirely electronic workflow are also huge! We’ve had users cut the document turnaround time with their clients from over a month to less than a day.'));
    },

    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Get Started',
            subtitle: 'Ready to try signing online for yourself? You can sign up for a free account to test it out. For unlimited documents and templates, take a look at our pro plans.',
            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl
        };
        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
    },

    render: function render() {
        return _jsx('div', {}, void 0, this.renderTitleSection(), this.renderBodySection(), this.renderCTASection());
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/how-to-sign-online.jsx
 ** module id = 825
 ** module chunks = 0
 **/